import { useEffect, useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
// @mui
import { Box } from "@mui/material";
// hooks
import useResponsive from "../../hooks/useResponsive";
// components
import { useSettingsContext } from "../../components/settings";
//
import Main from "./Main";
import Header from "./header";
import NavMini from "./nav/NavMini";
import NavVertical from "./nav/NavVertical";
import MainFooter from "../main/MainFooter";
import { useAuthContext } from "../../hooks/useAuthContext";

// ----------------------------------------------------------------------

const HORIZONTAL_ONLY_PAGES = ["listings","booking"];

export default function DashboardLayout() {
  const { themeMode, themeLayout, onChangeLayout } = useSettingsContext();
  const { user } = useAuthContext();

  const isDesktop = useResponsive("up", "lg");

  const [open, setOpen] = useState(false);

  const isNavHorizontal = themeLayout === "horizontal";

  const location = useLocation().pathname.split("/");

  const isNavMini = themeLayout === "mini";

  useEffect(() => {
    if (HORIZONTAL_ONLY_PAGES.includes(location[1]) || location.includes("floorplan-builder") || user.role === "user") {
      if(themeLayout !== "horizontal") {
        onChangeLayout({ target: { value: "horizontal" } });
      }
    } else {
      if(themeLayout === "horizontal") {
        onChangeLayout({ target: { value: "vertical" } }); 
      }
    }
  }, [location, user]);


  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const renderNavVertical = (
    <NavVertical openNav={open} onCloseNav={handleClose} />
  );

  if (location.includes("floorplan-builder")) {
    return (
      <>
      <Header onOpenNav={handleOpen} themeLayout={themeLayout} />
      <Box
        component="main"
        width="100%"
        height="100vh"
        sx={{
          backgroundColor: themeMode === "light" ? "#fff" : "#000",
          pt: 6,
          pb: 8,
        }}
      >
        <Outlet />
      </Box>
    </>
    )
  }

  if (
    HORIZONTAL_ONLY_PAGES.includes(location[1]) &&
    location[2] === "details"
  ) {
    return (
      <>
        <Box
          component="main"
          sx={{
            backgroundColor: themeMode === "light" ? "#fff" : "#000",
            pt: 12,
            pb: 10,
          }}
        >
          <Outlet />
        </Box>
        <MainFooter isCustomDesign isLightTheme={themeMode === "light"} />
      </>
    );
  }

  if (isNavHorizontal) {
    return (
      <>
        {location[1] === "listings" && location[2] === "list" ||
          location[1] === "booking" && location[2]?.startsWith("new") ? null : (
          <Header
            onOpenNav={handleOpen}
            displayLogo={true}
            themeLayout={themeLayout}
          />
        )}
        <Box>
          <Main>
            <Outlet />
          </Main>
        </Box>
        <MainFooter />
      </>
    );
  }

  if (isNavMini) {
    return (
      <>
        <Header onOpenNav={handleOpen} themeLayout={themeLayout} />

        <Box
          sx={{
            display: { lg: "flex" },
            minHeight: { lg: 1 },
          }}
        >
          {location[1] !== "listings" && isDesktop ? <NavMini /> : null}
          <Main>
            <Outlet />
          </Main>
        </Box>
        <MainFooter />
      </>
    );
  }
  return (
    <>
      <Header onOpenNav={handleOpen} themeLayout={themeLayout} />

      <Box
        sx={{
          display: { lg: "flex" },
          minHeight: { lg: 1 },
        }}
      >
        {renderNavVertical}
        <Main>
          <Outlet />
        </Main>
      </Box>
      <MainFooter />
    </>
  );
}
